import angular from 'angular';
import LoadMoreProductsController from "./loadMoreProducts.controller";

let loadMoreProducts = angular
    .module('loadMoreProducts', [])
    .controller('LoadMoreProductsController', LoadMoreProductsController);

export default loadMoreProducts;
